import React from "react";
import { Navigate } from "react-router-dom";
import { pendingFamilyInvitation } from "../lib/familyInvitation";

// Resume sign-in at the invitation; acceptance and email checks remain explicit.
export default function FamilyInvitationReturn({ children }) {
  const token = pendingFamilyInvitation();
  return token ? <Navigate to={"/family/join?token=" + encodeURIComponent(token)} replace /> : children;
}
